<section class="panel p-4">
  <div class="d-flex flex-wrap gap-3 align-items-end justify-content-between mb-3">
    <div>
      <h2 class="h5 mb-1">Listagem</h2>
      <div class="text-secondary small">
        Consulta de todas as solicitacoes pela data do pedido. Edite o periodo e baixe o .doc da portaria novamente.
      </div>
    </div>
  </div>

  <form class="row g-3 align-items-end mb-4" (ngSubmit)="filtrarLista()">
    <div class="col-md-3" *ngIf="empregadores.length > 1">
      <label class="form-label" for="empregadorListaFerias">Empregador</label>
      <select
        class="form-select"
        id="empregadorListaFerias"
        name="empregadorListaFerias"
        [ngModel]="empregadorSelecionado"
        (ngModelChange)="alterarEmpregador($event)">
        <option value="">Empregador</option>
        <option *ngFor="let empregador of empregadores" [value]="empregador.id">{{ empregador.razaoSocial }}</option>
      </select>
    </div>
    <div class="col-md-3">
      <label class="form-label" for="dataInicialFerias">Pedido de</label>
      <input
        class="form-control"
        id="dataInicialFerias"
        type="date"
        name="dataInicialFerias"
        [ngModel]="dataInicial"
        (ngModelChange)="alterarDataInicial($event)"
        required>
    </div>
    <div class="col-md-3">
      <label class="form-label" for="dataFinalFerias">Pedido ate</label>
      <input
        class="form-control"
        id="dataFinalFerias"
        type="date"
        name="dataFinalFerias"
        [ngModel]="dataFinal"
        (ngModelChange)="alterarDataFinal($event)"
        required>
    </div>
    <div class="col-md-2">
      <label class="form-label" for="statusFiltroFerias">Status</label>
      <select class="form-select" id="statusFiltroFerias" name="statusFiltroFerias" [(ngModel)]="status">
        <option value="">Todos</option>
        <option value="PENDENTE">Pendentes</option>
        <option value="DEFERIDA">Deferidas</option>
        <option value="INDEFERIDA">Indeferidas</option>
      </select>
    </div>
    <div class="col-md-1">
      <button class="btn btn-outline-primary w-100" type="submit">Filtrar</button>
    </div>
  </form>

  <p class="text-secondary small mb-2" *ngIf="resumoLista()">{{ resumoLista() }}</p>

  <div class="table-responsive" *ngIf="itens.length; else vazio">
    <table class="table table-sm align-middle">
      <thead>
        <tr>
          <th>Acao</th>
          <th>Protocolo</th>
          <th>Servidor</th>
          <th>Periodo</th>
          <th>Aquisitivo</th>
          <th>Portaria</th>
          <th>Status</th>
          <th>Solicitado por</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of itens">
          <td>
            <div class="d-flex gap-1">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                (click)="emEdicao(item) ? salvarLista(item) : editar(item)"
                [title]="emEdicao(item) ? 'Salvar' : 'Editar'"
                [attr.aria-label]="emEdicao(item) ? 'Salvar' : 'Editar'">
                <i class="bi" [ngClass]="emEdicao(item) ? 'bi-floppy' : 'bi-pencil-square'"></i>
              </button>
              <button
                *ngIf="emEdicao(item)"
                type="button"
                class="btn btn-outline-secondary btn-sm"
                title="Limpar"
                aria-label="Limpar"
                (click)="limparEdicao()">
                <i class="bi bi-x-lg"></i>
              </button>
              <button
                *ngIf="servicoPortaria.temPortaria(item)"
                type="button"
                class="btn btn-outline-primary btn-sm"
                title="Baixar .doc"
                aria-label="Baixar .doc"
                (click)="exportarPortaria(item)">
                <i class="bi bi-download"></i>
              </button>
            </div>
          </td>
          <td>{{ item.protocolo }}</td>
          <td>{{ item.matricula }} - {{ item.nome }}</td>
          <ng-container *ngIf="emEdicao(item); else leitura">
            <td>
              <div class="d-flex gap-1">
                <input class="form-control form-control-sm" type="date" [(ngModel)]="item.dataInicio" [name]="'inicio' + item.id">
                <input class="form-control form-control-sm" type="date" [(ngModel)]="item.dataFim" [name]="'fim' + item.id">
              </div>
            </td>
            <td>
              <input
                class="form-control form-control-sm"
                type="text"
                maxlength="9"
                [(ngModel)]="item.periodoAquisitivo"
                [name]="'aquisitivo' + item.id"
                placeholder="aaaa-aaaa">
            </td>
          </ng-container>
          <ng-template #leitura>
            <td>{{ periodo(item) }}</td>
            <td>{{ item.periodoAquisitivo || '—' }}</td>
          </ng-template>
          <td>{{ portaria(item) }}</td>
          <td>{{ rotuloStatus(item.status) }}</td>
          <td>{{ rotuloOrigem(item) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #vazio>
    <p class="text-secondary mb-0">Nenhuma solicitacao neste periodo.</p>
  </ng-template>

  <div class="d-flex flex-wrap gap-2 justify-content-between align-items-center mt-3" *ngIf="totalPaginas > 1">
    <span class="text-secondary small">Pagina {{ pagina }} de {{ totalPaginas }}</span>
    <div class="btn-group">
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        [disabled]="pagina <= 1"
        (click)="irParaPagina(pagina - 1)">
        Anterior
      </button>
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        [disabled]="pagina >= totalPaginas"
        (click)="irParaPagina(pagina + 1)">
        Proxima
      </button>
    </div>
  </div>
</section>
